import * as _ from 'lodash';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import nvSdcModule from './../../../sdc/nv.sdcModule.module';
import { AG_GRID_NUMBER_FILTER_TYPES } from './../../services/sorter/ag-grid/ag-grid-filter.constant';
import { ISorterColumn } from './../../sorter-column/sorter-column.service';

angular.module(nvSdcModule).controller('ToolbarFiltersWidgetCtrl', ToolbarFiltersWidgetCtrl);

function ToolbarFiltersWidgetCtrl($scope, $state, SorterColumn, SDCStore, sdcActions, ObjectCache, ImUser: ImUser) {
  this.sdcView = 'grid';
  this.sdcKey = SDCStore.getSdcKeyFromUiState();

  this.setWidget = () => {
    this.filters = this.parsedFilterParam || SDCStore.getFilter();
    this.lockedFilters = SDCStore.getLockedFilters();
    this.totalStudents = this.totalStudentsCount || SDCStore.getAllStudents().length;
    this.totalFilteredStudents = this.filteredStudentsCount || SDCStore.getFilteredStudents(null, false).length;
    this.currentFilters = this.createCurrentFilters(this.filters, this.lockedFilters);
    this.selectAll = true;
  };

  this.toggleAll = () => {
    this.selectAll = !this.selectAll;

    _.each(this.currentFilters.unlocked, (filter: any) => {
      filter.apply = this.selectAll;
    });
  };

  this.openFiltersWidget = (menu, ev) => {
    // reset ng-model for apply filter value to true
    this.selectAll = true;

    _.each(this.currentFilters.unlocked, (filter: any) => {
      filter.apply = true;
    });

    menu(ev);
  };

  this.applyFilterChanges = () => {
    _.each(this.currentFilters.unlocked, (filter: any) => {
      if (!filter.apply) {
        sdcActions.clearFilterForColumn(filter.sorterColumnKey);
        const newFilter = SDCStore.getFilter();
        const sdcView = this.sdcView;
        const sdcKey = this.sdcKey;
        sdcActions.setEntireFilter({ newFilter, sdcView, sdcKey });
      }
    });
  };

  this.clearAll = () => {
    const state = 'main.school.single-student-filter-all';

    sdcActions.clearAllUnlockedFilters();
    $state.go(state, { filter: ObjectCache.cacheObject({}) });
  };

  this.renderNumericFilter = filter => {
    switch (filter.type) {
      case AG_GRID_NUMBER_FILTER_TYPES.EQUALS:
        return '=';
      case AG_GRID_NUMBER_FILTER_TYPES.NOT_EQUALS:
        return '<>';
      case AG_GRID_NUMBER_FILTER_TYPES.LESS_THAN:
        return '<';
      case AG_GRID_NUMBER_FILTER_TYPES.LESS_THAN_OR_EQUAL:
        return '<=';
      case AG_GRID_NUMBER_FILTER_TYPES.GREATER_THAN:
        return '>';
      case AG_GRID_NUMBER_FILTER_TYPES.GREATER_THAN_OR_EQUAL:
        return '>=';
      case AG_GRID_NUMBER_FILTER_TYPES.RANGE:
        return 'between';
      default:
        return undefined;
    }
  };

  this.createCurrentFilters = (filters, lockedFilters) => {
    const currentFilters = {
      unlocked: [],
      locked: [],
      total: 0,
    };
    const filtersCopy = angular.copy(filters);

    _.each(filtersCopy, (v: any, k) => {
      const sorterColDef = SorterColumn.getByColumnKey(k);
      const locked = _.includes(lockedFilters, k);
      const filterVal = this.renderFilterValues(v, sorterColDef);

      // numeric filters
      if (v.type) {
        v.filterType = this.renderNumericFilter(v);
      }

      const currentFilter = {
        filterCol: `${sorterColDef.humanName}:`,
        filterType: v.filterType,
        filterVal,
        apply: true,
        sorterColumnKey: k,
      };

      locked ? currentFilters.locked.push(currentFilter) : currentFilters.unlocked.push(currentFilter);
      currentFilters.total++;
    });
    return currentFilters;
  };

  this.toNumber = (val, sorterColDef) => {
    const sorterColDefDataTypeOptions = sorterColDef.dataTypeOptions;
    if (sorterColDefDataTypeOptions && sorterColDefDataTypeOptions.numberType === 'NUMBER') {
      return `${parseFloat(val.toFixed(2))}`;
    }
    return `${parseFloat((val * 100).toFixed(2))}%`;
  };

  this.renderFilterValues = (v, sorterColDef: ISorterColumn) => {
    if (v.length === 1) {
      const val = v[0];

      if (val === undefined) {
        return 'undefined';
      }

      if (val === null) {
        return '-';
      }

      if (val === '[]') {
        return '(None)';
      }

      if (sorterColDef.dataType === 'USER_MINI') {
        return ImUser.getFullNameWithEmailFromMini(val);
      } else {
        return val;
      }
    } else if (v.length === 0) {
      return (v = 'None');
    } else if (v.length > 1) {
      return (v = 'Multiple');
    } else if (v.type === AG_GRID_NUMBER_FILTER_TYPES.RANGE) {
      // if range, show min and max

      let mini = this.toNumber(v.filter.min, sorterColDef);
      let maxi = this.toNumber(v.filter.max, sorterColDef);

      v = `${mini} & ${maxi}`;
    } else if (v.in) {
      if (v.in[0] === false) {
        v.in[0] = 'No';
      }

      if (v.in[0] === null) {
        return '(Blanks)';
      }

      if (v.in[1] === null) {
        v.in[1] = ' or no value found';
      }

      v = v.in.join();
    } else if (!_.hasOwnProperty(v.filter)) {
      v = this.toNumber(v.filter, sorterColDef);
    } else {
      return v;
    }

    return v;
  };

  $scope.$listenTo(SDCStore, ['filter'], this.setWidget);
}
